var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.classBtnType,on:{"click":function($event){return _vm.$emit('clicked')}}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }